import { SaveOutlined } from "@ant-design/icons";
import { Col, InputNumber, Row, Select } from "antd";
import { get } from "lodash";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import Button from "../../../components/functional_components/Button/PFButton";
import DetailBox from "../../../components/functional_components/DetailBox/DetailBox";
import { setLoading } from "../../../redux/ducks/Loading";
import { setTimesheetApproval } from "../../../redux/ducks/Section";
import SettingsApi from "../../../services/api/Settings";
import { showError, showSuccess } from "../../../utils/utilities";

const Settings = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [state, setState] = useState({
    loading: false,
    daysNumber: null,
    timesheetApproverRole: null,
    runningValue: null,
  });

  const timesheetApproverOptions = [
    { label: <span>{t("settings.timesheetApprover")}</span>, value: "TIMESHEET_APPROVER" },
    { label: <span>{t("settings.pm")}</span>, value: "PM" },
  ];

  const runningValueOptions = [
    {
      label: <span>{t("settings.timesheetApproved")}</span>,
      value: "TIMESHEET_APPROVED",
    },
    {
      label: <span>{t("settings.timesheetInserted")}</span>,
      value: "TIMESHEET_INSERTED",
    },
  ];

  useEffect(() => {
    getCurrentSettings();
  }, []);

  const getCurrentSettings = async () => {
    dispatch(setLoading(true));
    const settings = await SettingsApi.getSettings();
    if (!settings.error && settings.data) {
      setState((prevState) => ({
        ...prevState,
        daysNumber: get(settings, "data.invoiceClosingDay", 1),
        timesheetApproverRole: get(settings, "data.timesheetApprover", null),
        runningValue: get(settings, "data.timesheetRunningValue", null),
      }));
    } else {
      showError(get(settings, "error.messageCode", "ER000"));
    }
    dispatch(setLoading(false));
  };

  const setSettings = async () => {
    setState((prevState) => ({ ...prevState, loading: true }));
    const saveResponse = await SettingsApi.saveSettings({
      invoiceClosingDay: state.daysNumber,
      timesheetApprover: state.timesheetApproverRole,
      timesheetRunningValue: state.runningValue,
    });
    if (!saveResponse.error) {
      showSuccess();
      dispatch(setTimesheetApproval({ timesheetApproval: state.timesheetApproverRole }));
      getCurrentSettings();
    } else {
      showError(get(saveResponse, "error.messageCode", "ER000"));
    }
    setState((prevState) => ({ ...prevState, loading: false }));
  };

  const changeInput = (daysNumber) => {
    setState((prevState) => ({ ...prevState, daysNumber }));
  };

  return (
    <DetailBox title={t("settings.settingsTitle")}>
      <Row>
        <Col>
          <Row>
            <label htmlFor="daysNumber" className="fw-bold">
              {t("settings.daysNumber")}
            </label>
          </Row>
          <Row>
            <InputNumber
              className="mt-10"
              id="daysNumber"
              min={1}
              max={31}
              value={state.daysNumber}
              onChange={changeInput}
              placeholder="0"
            />
          </Row>
        </Col>

        <Col offset={2}>
          <Row>
            <label htmlFor="daysNumber" className="fw-bold">
              {t("settings.chooseTimesheetApproverRole")}*
            </label>
          </Row>
          <Row className="mt-10">
            <Select
              showSearch
              placeholder={t("settings.chooseTimesheetApproverRole")}
              id="timesheetApproverRole"
              name="timesheetApproverRole"
              onChange={(value) => setState({ ...state, timesheetApproverRole: value })}
              value={state.timesheetApproverRole}
              options={timesheetApproverOptions}
            />
          </Row>
        </Col>

        <Col offset={2}>
          <Row>
            <label htmlFor="runningValue" className="fw-bold">
              {t("settings.runningValue")}*
            </label>
          </Row>
          <Row className="mt-10">
            <Select
              showSearch
              placeholder={t("settings.runningValue")}
              id="runningValue"
              name="runningValue"
              onChange={(value) => setState({ ...state, runningValue: value })}
              value={state.runningValue}
              options={runningValueOptions}
              popupMatchSelectWidth={false}
            />
          </Row>
        </Col>
      </Row>
      <Button
        isDisabled={state.timesheetApproverRole === null || state.runningValue === null}
        floatRight
        currentSize="large"
        currentIcon={<SaveOutlined className="icon-medium" />}
        clickCallback={setSettings}
        isLoading={state.loading}
      />
    </DetailBox>
  );
};

export default Settings;
